import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "admin-nav" }
const _hoisted_2 = { class: "sidebar-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["admin-sidebar", { 'is-open': _ctx.isOpen }])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleNavItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.to
          }, [
            _createVNode(_component_router_link, {
              to: item.to,
              "active-class": "active-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoutUser && _ctx.logoutUser(...args))),
        class: "btn btn-danger btn-block"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1),
        _createTextVNode(" Logout ")
      ]))
    ])
  ], 2))
}